import { FC, ReactNode } from 'react';
import styles from './SkeletonList.css';

interface ISkeletonListProps {
  items: ReactNode[];
}

export const SkeletonList: FC<ISkeletonListProps> = ({ items }) => {
  return (
    <ul className={styles['skeleton-list']}>
      {items.map((item, index) => (
        <li key={index} className={styles['skeleton-item']}>
          {item}
        </li>
      ))}
    </ul>
  );
};
